import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import axios from "axios";
import {MonstrousAbility} from "../../../server/monster";

interface Props {
    open: boolean
    onClose: () => void
    onCreated: (ability: MonstrousAbility) => void
}

export function CreateMonstrousAbilityDialog({open, onClose, onCreated}: Props) {
    const [name, setName] = useState('')
    const [call, setCall] = useState('')
    const [type, setType] = useState<'IMMUNITY' | 'STRENGTH' | 'WEAKNESS'>('IMMUNITY')
    const [error, setError] = useState<string | null>(null)

    async function handleSubmit() {
        try {
            const {data} = await axios.post('/monsters/monstrous-abilities', {name, call, type})
            onCreated(data as MonstrousAbility)
            setName(''); setCall(''); setType('IMMUNITY'); setError(null)
            onClose()
        } catch (err: any) {
            setError(err?.response?.data?.error ?? 'Failed to create ability')
        }
    }

    function handleClose() {
        setName(''); setCall(''); setType('IMMUNITY'); setError(null)
        onClose()
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>Create Monstrous Ability</DialogTitle>
            <DialogContent>
                <TextField fullWidth label="Name" value={name}
                           onChange={e => { setName(e.target.value); setError(null) }}
                           error={!!error} helperText={error ?? ''}
                           sx={{mt: 1, mb: 2}}/>
                <TextField fullWidth label="Call" value={call}
                           onChange={e => setCall(e.target.value)}
                           sx={{mb: 2}}/>
                <FormControl fullWidth>
                    <InputLabel>Type</InputLabel>
                    <Select label="Type" value={type} onChange={e => setType(e.target.value as any)}>
                        <MenuItem value="IMMUNITY">Immunity</MenuItem>
                        <MenuItem value="STRENGTH">Strength</MenuItem>
                        <MenuItem value="WEAKNESS">Weakness</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSubmit} disabled={!name || !call}>Create</Button>
            </DialogActions>
        </Dialog>
    )
}
